import styled, { css } from "styled-components"

import SignUp from "components/sign-up"

export const Container = styled.div`
  position: sticky;
  top: 10rem;
  left: 0;
  width: 100%;
  padding: 2rem;
  float: left;
  border: 1.5px solid #767676;
  background-color: #fff;

  &:first-of-type {
    margin-top: 2rem;
  }
`

export const Title = styled.h3`
  font-weight: 500;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3rem;
  line-height: 1.13;
  letter-spacing: -0.0384rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const Body = styled.div`
  padding: 2rem 0;
`

export const Details = styled.p`
  margin: 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.9rem;
  line-height: 1.37;
  letter-spacing: -0.0304rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const SignUpForm = styled(SignUp)`
  width: 100%;
  padding: 0;

  form {
    max-width: unset;

    div {
      width: 100%;

      input:not([type="submit"]) {
        margin: 1.5rem 0;
        padding-right: 2.4rem;
      }

      input[type="submit"] {
        position: relative;
        width: 100%;
        margin: 1.5rem 0;
        background-color: #ec5d2a;
      }

      ${({ submitted }) =>
        Boolean(submitted) &&
        css`
          height: auto;
          margin: 1.5rem 0;
          line-height: 1.5;
        `}
    }
  }
`
